import { Link as RRLink } from "react-router-dom";
import styled from "styled-components";

export const Container = styled.div`
  width: 100%;
  margin: 20px auto 0;

  ${({ theme }) => theme.old.breakpoints.isTab} {
    padding: 0 ${({ theme }) => theme.old.sizes.sidesMargin.small};
  }
`

export const Wrapper = styled.div`
  width: 100%;
  max-width: 775px;
  margin: 0 auto;
`

export const Title = styled.h1`
  font-size: ${({ theme }) => theme.old.fonts.size.extrahuge};
  font-weight: ${({ theme }) => theme.old.fonts.weight.semibold};
  color: ${({ theme }) => theme.old.colors.white};
  margin-bottom: 12px;
`

export const Description = styled.p`
  font-size: ${({ theme }) => theme.old.fonts.size.normal};
  font-weight: ${({ theme }) => theme.old.fonts.weight.regular};
  color: ${({ theme }) => theme.old.colors.gray[525]};
  margin-bottom: 32px;
`

export const Text = styled.p`
  color: ${({ theme, $isWhite }) => $isWhite
    ? theme.old.colors.white
    : theme.old.colors.gray[525]
  };

  font-weight: ${({ theme, $isBold }) => $isBold
    ? theme.old.fonts.weight.semibold
    : theme.old.fonts.weight.normal
  };

  font-size: ${({ theme }) => theme.old.fonts.size.normal};

  margin-top: ${({ $mt }) => `${$mt}px`};

  line-height: 24px;
`

export const BulletList = styled.ul`
  color: ${({ theme }) => theme.old.colors.gray[525]};

  margin-left: 30px;
`

export const Link = styled(RRLink)`
  color: ${({ theme }) => theme.old.colors.white};
  text-decoration: underline;
  text-decoration-color: ${({ theme }) => theme.old.colors.gray[300]};
  transition: text-decoration-color 200ms;

  :hover {
    text-decoration-color: ${({ theme }) => theme.old.colors.white};
  }
`
